import { render } from "./AlterarSenha.vue?vue&type=template&id=ae9fb35e"
import script from "./AlterarSenha.vue?vue&type=script&lang=js"
export * from "./AlterarSenha.vue?vue&type=script&lang=js"

import "./AlterarSenha.vue?vue&type=style&index=0&id=ae9fb35e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__